import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetSensorType } from 'src/app/models/sensor-type/get-sensor-type';
import { GetSensorTypeGraph } from 'src/app/models/sensor-type/get-sensor-type-graph';
import { GetGraph } from 'src/app/models/panelIOT/getGraph';
import { GetSensorSubType } from 'src/app/models/sensor-type/get-sensor-subtype';
import { GetNotification } from 'src/app/models/notification/get-notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'Notification';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getList(parameters: any): Observable<GetNotification> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetNotification>(`${this.REQUEST_URL}/pag`, { params: httpParams });
  }

  getListAllLast(idUser): Observable<GetNotification> {
    return this.httpClient.get<GetNotification>(`${this.REQUEST_URL}/last/${idUser}`);
  }

  checked(id) {
    return this.httpClient.post<any>(`${this.REQUEST_URL}/checked/${id}`,null);
  }

  checkedAll() {
    return this.httpClient.post<any>(`${this.REQUEST_URL}/checked`,null);
  }

  getEnterpriseAlertSetting(enterpriseId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.REQUEST_URL}/setting/${enterpriseId}`);
  }

  updateEnterpriseSettingEmail(payload): Observable<Error> {
    return this.httpClient.post<Error>(`${this.REQUEST_URL}/setting/add-user`, payload);
  }
}
